import React, { Component } from "react";
import FieldsVolleyball from "./FieldsVolleyball";
import FieldsRaquetNet from "./FieldsRaquetNet";
import FieldsTennis from "./FieldsTennis";
import ConditionalComponent from "../ConditionalComponent";
import { Fieldset } from "../../theme/styled";
import { FormattedMessage } from "react-intl";

class FieldsRaquet extends Component {
  render() {
    return (
      <Fieldset>
        <h2>
          <FormattedMessage id="other.title" defaultMessage="Inne dyscypliny" />
        </h2>
        <FieldsRaquetNet />
        <ConditionalComponent
          conditions={{ minX: 20 }}
          component={FieldsVolleyball}
        />
        <ConditionalComponent
          conditions={{ minX: 28 }}
          component={FieldsTennis}
        />
      </Fieldset>
    );
  }
}

export default FieldsRaquet;
